



























import { Component, Prop, Vue } from "vue-property-decorator";
import { SecinfoS } from "@/types";
import TrainBoxS from "@/components/TrainBoxS.vue";
import { UnyoList } from "@/apis/kostl/vehicles/@types";

@Component({
  components: {
    TrainBoxS
  }
})
export default class LineSectionS extends Vue {
  @Prop({ required: true })
  secinfo!: SecinfoS;
  @Prop({ required: true })
  unyoList!: UnyoList;

  getFlexDirection(pos: string, ki: boolean) {
    if (pos.length > 3) {
      return ki ? "column-reverse" : "column";
    } else {
      return ki ? "row" : "row-reverse";
    }
  }
}
